import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../Services/authService";
import { toast } from "react-toastify";
import "../../../auth-modern.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        const body = { email };

        AuthService.verifyEmail(body)
            .then((res) => {
                const message = res.data?.message || res.message || "Email verified, reset your password!";
                toast.success(message);
                navigate("/", { state: { email } });
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Something went wrong, try again!");
            });
    };

    return (
        <div className="auth-modern-wrapper">
            <div className="auth-modern-card">
                <div className="auth-logo-container">
                    <Link to="/">
                        <img src="/assets/images/logo-dark.png" alt="logo" height={32} />
                    </Link>
                </div>

                <h2 className="auth-welcome-text">Reset Password</h2>

                <div className="auth-input-group mt-4">
                    <div className="alert alert-success text-center mb-4" style={{ fontSize: '13px', borderRadius: '8px' }}>
                        Enter your Email and proceed to set a new password!
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="auth-input-group">
                        <input
                            type="email"
                            className="auth-input"
                            placeholder=" "
                            id="useremail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <label className="auth-label" htmlFor="useremail">Email Address</label>
                    </div>

                    <div className="mt-4">
                        <button className="auth-primary-btn" type="submit">
                            Next
                        </button>
                    </div>

                    <div className="mt-4 text-center">
                        <p className="mb-0" style={{ fontSize: '13px' }}>
                            Remember it? <Link to="/" className="auth-link">Signin</Link>
                        </p>
                    </div>
                </form>

                <p className="auth-footer-text">
                    © {new Date().getFullYear()} Planit. Developed by <a href="https://websouls.com/" target="_blank" rel="noopener noreferrer" className="auth-link">WebSouls</a>
                </p>

            </div>
            
            <div className="auth-bottom-help">
                <Link to="/">Need help?</Link>
            </div>
        </div>
    );
};

export default ForgotPassword;
